const convertBooleanToYesNo = (boolean) => {
  return boolean ? "Yes" : "No";
};

export default convertBooleanToYesNo;
